import { Button } from '@mui/material'
import { useStyles } from './styles'
import { ETranslationNs } from 'src/types'
import { HelperWrapper } from '../helper-wrapper'

interface IProps {
  returnBack: () => void
}

export const ReturnBackButton = ({ returnBack }: IProps) => {
  const classes = useStyles()

  return (
    <Button
      variant="outlined"
      size="small"
      className={classes.returnBackButton}
      onClick={returnBack}
    >
      <HelperWrapper ns={ETranslationNs.UserProfile} t="return-back-button-text" />
    </Button>
  )
}
